export const URL = process.env.REACT_APP_BACKEND_URL;
export const MAX_LENGTH_STORY = 600;
export let token = window.sessionStorage.getItem('token');
